import axios from "axios";
import toast from "react-hot-toast";
import { token } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const consultantList = (planData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CONSULATNT_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/consultant/list`,
       planData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_CONSULATNT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_CONSULATNT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_CONSULATNT_LIST_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addConsultant = (Data) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_CONSULATNT_REQUEST" });
      console.log("BASE_URL:", process.env.REACT_APP_API_BASE_URL);

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/consultant/add`,
        Data,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_CONSULATNT_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_CONSULATNT_FAIL", payload: data });
        toast.error("Something went wrong!!");
      }
    } catch (error) {
      dispatch({ type: "ADD_CONSULATNT_FAIL", payload: error.message });
      toast.error("Something went wrong!!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const viewConsultantProfile = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_CONSULATNT_REQUEST" });


      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/consultant/profile/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_CONSULATNT_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_CONSULATNT_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "VIEW_CONSULATNT_FAIL", payload: error.message });
      toast.error("Something went wrong!!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editConsultant = (teamData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_PLAN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/staff/alllist`,
        teamData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_PLAN_SUCCESS", payload: data });
      } else {
        dispatch({ type: "EDIT_PLAN_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EDIT_PLAN_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const blockUnblockConsultant = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "BLOCK_UNBLOCK_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/consultant/block-unblock`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "BLOCK_UNBLOCK_SUCCESS", payload: data });
      } else {
        dispatch({ type: "BLOCK_UNBLOCK_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "BLOCK_UNBLOCK_FAILED",
        payload: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
export const acceptDeclineConsultant = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ACCEPT_DECLINE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/consultant/change-status`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ACCEPT_DECLINE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "ACCEPT_DECLINE_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ACCEPT_DECLINE_FAILED",
        payload: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
export const getConsultantProjects = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CONSULTANT_PROJECTS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/consultant/project-list`,
        id,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CONSULTANT_PROJECTS_SUCCESS", payload: data });
        toast.success("Projects fetched successfully!");
        return data;
      } else {
        dispatch({ type: "GET_CONSULTANT_PROJECTS_FAIL", payload: data });
        toast.error("Failed to fetch projects!");
      }
    } catch (error) {
      dispatch({ type: "GET_CONSULTANT_PROJECTS_FAIL", payload: error.message });
      toast.error("Something went wrong while fetching projects!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
export const addStatus=(payload)=>{
   return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_STATUS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/consultant/project-approval-by-builder`,
        payload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_STATUS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "ADD_STATUS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_STATUS_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
}

